import React from 'react'

import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
  NonIndexRouteObject
} from 'react-router-dom'

import LoginPage from './Containers/LoginPage/LoginPage'
import PhotosPage from './Containers/PhotosPage/PhotosPage'
import RootLayout from './Containers/RootLayout/RootLayout'
import ValentinesPage from './Containers/ValentinesPage/ValentinesPage'

interface UseAthenticationProps {
  pageContent: React.ReactElement
}

const UseAuthentication: React.FC<UseAthenticationProps> = ({
  pageContent
}) => {
  const isAuthenticated = localStorage.getItem('loggedIn') === 'true'
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <RootLayout>{pageContent}</RootLayout>
}

export const RouteInfo = () => {
  const routes: NonIndexRouteObject[] = [
    {
      path: '/',
      children: [
        {
          index: true,
          element: <UseAuthentication pageContent={<PhotosPage />} />
        },
        {
          path: 'valentines',
          element: <UseAuthentication pageContent={<ValentinesPage />} />
        },
        {
          path: 'login',
          element: <LoginPage />
        }
      ]
    }
  ]

  return routes
}

const Routes = () => {
  const routeInfo = RouteInfo()
  const routes = createBrowserRouter(routeInfo)

  return <RouterProvider router={routes} />
}

export default Routes
